// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicZoneControllerCreateData } from './PublicZoneControllerCreateData.gen';
import type { PublicZoneControllerCreateErrors } from './PublicZoneControllerCreateErrors.gen';
import type { PublicZoneControllerCreateResponses } from './PublicZoneControllerCreateResponses.gen';
import type { PublicZoneControllerDeleteData } from './PublicZoneControllerDeleteData.gen';
import type { PublicZoneControllerDeleteErrors } from './PublicZoneControllerDeleteErrors.gen';
import type { PublicZoneControllerDeleteResponses } from './PublicZoneControllerDeleteResponses.gen';
import type { PublicZoneControllerGetAllData } from './PublicZoneControllerGetAllData.gen';
import type { PublicZoneControllerGetAllErrors } from './PublicZoneControllerGetAllErrors.gen';
import type { PublicZoneControllerGetAllResponses } from './PublicZoneControllerGetAllResponses.gen';
import type { PublicZoneControllerGetAllZonesData } from './PublicZoneControllerGetAllZonesData.gen';
import type { PublicZoneControllerGetAllZonesErrors } from './PublicZoneControllerGetAllZonesErrors.gen';
import type { PublicZoneControllerGetAllZonesResponses } from './PublicZoneControllerGetAllZonesResponses.gen';
import type { PublicZoneControllerGetCombinedZoneByZoneNumbersData } from './PublicZoneControllerGetCombinedZoneByZoneNumbersData.gen';
import type { PublicZoneControllerGetCombinedZoneByZoneNumbersErrors } from './PublicZoneControllerGetCombinedZoneByZoneNumbersErrors.gen';
import type { PublicZoneControllerGetCombinedZoneByZoneNumbersResponses } from './PublicZoneControllerGetCombinedZoneByZoneNumbersResponses.gen';
import type { PublicZoneControllerGetOneByNumberData } from './PublicZoneControllerGetOneByNumberData.gen';
import type { PublicZoneControllerGetOneByNumberErrors } from './PublicZoneControllerGetOneByNumberErrors.gen';
import type { PublicZoneControllerGetOneByNumberResponses } from './PublicZoneControllerGetOneByNumberResponses.gen';
import type { PublicZoneControllerGetOneData } from './PublicZoneControllerGetOneData.gen';
import type { PublicZoneControllerGetOneErrors } from './PublicZoneControllerGetOneErrors.gen';
import type { PublicZoneControllerGetOneResponses } from './PublicZoneControllerGetOneResponses.gen';
import type { PublicZoneControllerUpdateData } from './PublicZoneControllerUpdateData.gen';
import type { PublicZoneControllerUpdateErrors } from './PublicZoneControllerUpdateErrors.gen';
import type { PublicZoneControllerUpdateResponses } from './PublicZoneControllerUpdateResponses.gen';

export class PublicZoneController {
    /**
     * Get zones
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicZoneControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicZoneControllerGetAllResponses, PublicZoneControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/zones-public',
            ...options
        });
    }
    
    /**
     * Get all zones.
     */
    public static getAllZones<ThrowOnError extends boolean = false>(options?: Options<PublicZoneControllerGetAllZonesData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicZoneControllerGetAllZonesResponses, PublicZoneControllerGetAllZonesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/zones',
            ...options
        });
    }
    
    /**
     * Create zone.
     *
     * Require: `PERMISSION_ZONES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_ZONE** - Zone does not exist or is missing in the given ticket combination.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<PublicZoneControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<PublicZoneControllerCreateResponses, PublicZoneControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/zones',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete zone.
     *
     * If an entity is being used, 409 Conflict will be returned.<br>
     * Require: `PERMISSION_ZONES_DELETE`
     */
    public static delete<ThrowOnError extends boolean = false>(options: Options<PublicZoneControllerDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<PublicZoneControllerDeleteResponses, PublicZoneControllerDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/zones/{id}',
            ...options
        });
    }
    
    /**
     * Get zone by id.
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<PublicZoneControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<PublicZoneControllerGetOneResponses, PublicZoneControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/zones/{id}',
            ...options
        });
    }
    
    /**
     * Update zone.
     *
     * Require: `PERMISSION_ZONES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static update<ThrowOnError extends boolean = false>(options: Options<PublicZoneControllerUpdateData, ThrowOnError>) {
        return (options.client ?? client).put<PublicZoneControllerUpdateResponses, PublicZoneControllerUpdateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/zones/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get zone by id.
     */
    public static getOneByNumber<ThrowOnError extends boolean = false>(options: Options<PublicZoneControllerGetOneByNumberData, ThrowOnError>) {
        return (options.client ?? client).get<PublicZoneControllerGetOneByNumberResponses, PublicZoneControllerGetOneByNumberErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/zones-by-number/{number}',
            ...options
        });
    }
    
    /**
     * Returns combined zone by zone numbers.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_ZONE** - Zone does not exist or is missing in the given ticket combination.
     */
    public static getCombinedZoneByZoneNumbers<ThrowOnError extends boolean = false>(options: Options<PublicZoneControllerGetCombinedZoneByZoneNumbersData, ThrowOnError>) {
        return (options.client ?? client).get<PublicZoneControllerGetCombinedZoneByZoneNumbersResponses, PublicZoneControllerGetCombinedZoneByZoneNumbersErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/zones-combined-by-zones',
            ...options
        });
    }
}
